export default "__VITE_ASSET__eNVAWpni__"